import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, analytics, identifyUser } from '@/lib/analytics';
import { useAuth } from '@/contexts/AuthContext';

// Custom hook for analytics tracking
export const useAnalytics = () => {
  const location = useLocation();
  const { session, userProfile } = useAuth();

  // Track page views on route changes
  useEffect(() => {
    const url = window.location.origin + location.pathname + location.search;
    trackPageView(url);
  }, [location]);

  // Identify user when they sign in
  useEffect(() => {
    if (session?.user) {
      identifyUser(session.user.id, {
        email: session.user.email,
        has_profile: !!userProfile,
        user_type: userProfile?.isCPA ? 'cpa' : 'accountant'
      });
    }
  }, [session, userProfile]);

  return analytics;
};

// Hook for tracking specific events
export const useEventTracking = () => {
  return analytics;
};